import type {
    MeetingTypeEditOptionState,
    SchedulingPolicyState,
    AvailabilityState,
} from '../store/schema/MeetingTypeEditOptionState';
import { AvailabilityType } from '../store/schema/MeetingTypeEditOptionState';
import BookingPrivacyType from '../store/schema/BookingPrivacyType';
import type { EnhancedLocation } from 'owa-graph-schema';
import type SchedulingPolicy from 'owa-service/lib/contract/SchedulingPolicy';
import type UserInfo from '../store/schema/UserInfo';
import {
    bookWithMeNeedsTitleWarningText,
    bookwithme_bookingWarnAboutInvalidEmailsInWell,
    bwmLongDescriptionError,
} from '../components/compose/ComposeServiceFull.locstring.json';
import loc from 'owa-localize';
import { defaultEmojiMeetingType, getLargeThemeImageUrl } from 'bookwithme-shared';

export default function initializeMeetingTypeEditState(
    defaultSchedulingPolicy?: SchedulingPolicy
): MeetingTypeEditOptionState {
    const themeImageUrl = getLargeThemeImageUrl(1); // setting it to a default image everytime
    const defaultDurationMinutes: number = 30;
    const defaultMinLeadTime: number = defaultSchedulingPolicy?.LeadTimeInMinutes || 60;
    const defaultMaxLeadTime: number = defaultSchedulingPolicy?.EndOfBookingWindowInDays || 90;
    const defaultTimeSlotIntervalInMinutes: number =
        defaultSchedulingPolicy?.TimeSlotIntervalInMinutes || 30;
    const initMeetingTypeEditOptionState: MeetingTypeEditOptionState = {
        id: '',
        name: '',
        description: '',
        inboxReminders: [],
        charm: 0,
        categoryNames: [],
        duration: defaultDurationMinutes,
        location: {
            DisplayName: '',
            Annotation: '',
        } as EnhancedLocation,
        isOnlineMeeting: true,
        schedulingPolicy: {
            leadTimeForBookingsInMinutes: defaultMinLeadTime,
            leadTimeForCancellationsInMinutes: defaultMinLeadTime,
            leadTimeInMinutes: defaultMinLeadTime,
            endOfBookingWindowInDays: defaultMaxLeadTime,
            timeSlotIntervalInMinutes: defaultTimeSlotIntervalInMinutes,
        } as SchedulingPolicyState,
        availability: {
            availabilityType: AvailabilityType.DefaultSetup,
            isDateRestricted: false,
            startDate: undefined,
            endDate: undefined,
            customHours: undefined,
            isDirty: false,
        } as AvailabilityState,
        hasError: false,
        showErrorMessage: false,
        excludeFromSelfService: false,
        preBuffer: 0,
        postBuffer: 0,
        needsTitle: {
            errorString: loc(bookWithMeNeedsTitleWarningText),
            hasError: false,
            scrollIntoView: false,
        },
        validateDescription: {
            errorString: loc(bwmLongDescriptionError),
            hasError: false,
            scrollIntoView: false,
        },
        validateMinAndMax: {
            errorString: '',
            hasError: false,
            scrollIntoView: false,
        },
        privacyType: BookingPrivacyType.MeetingType,
        themeImage: themeImageUrl,
        emojiCode: defaultEmojiMeetingType, //📅
        attendees: [] as UserInfo[],
        invalidRecipientEmail: {
            errorString: loc(bookwithme_bookingWarnAboutInvalidEmailsInWell),
            hasError: false,
            scrollIntoView: false,
        },
        createLink: false,
        isAttendeeAuthRequired: false,
        additionalInformation: '',
        validateAvailability: {
            hasWarning: false,
            hasError: false,
        },
        origin: '',
        bookingUrlCodes: [],
    };

    return initMeetingTypeEditOptionState;
}
